import { parseOrgPath, type OrgLocation } from '@foundation/shared';

/**
 * มูลนิธิของหน้านี้ — อ่านจาก path ของตัวเอง
 *
 * ตัวตีความ path อยู่ใน @foundation/shared เพื่อให้ทั้งสามเว็บใช้กติกาเดียวกัน
 * และมีเทสต์คุมอยู่ (ดู packages/shared/src/orgSlug.ts ว่าทำไมถึงสำคัญ)
 */
export function readOrgLocation(pathname: string = window.location.pathname): OrgLocation {
  return parseOrgPath(pathname);
}

export type { OrgLocation };

export interface OrgConfig {
  slug: string;
  nameTh: string;
  nameEn: string | null;
  liffId: string | null;
  logoDataUri: string | null;
}
